
import Vue from "vue";

export default Vue.extend({
  name: "PaginationControls",
  props: {
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    itemLabel: {
      type: String,
      default: "items"
    },
    limitOptions: {
      type: Array as () => number[],
      default: () => [5, 10, 20, 50, 100]
    }
  },
  data() {
    return {
      localPage: this.page,
      localLimit: this.limit
    };
  },
  computed: {
    totalPages(): number {
      return Math.ceil(this.total / this.localLimit);
    },
    startItem(): number {
      return (this.localPage - 1) * this.localLimit + 1;
    },
    endItem(): number {
      const end = this.localPage * this.localLimit;
      return Math.min(end, this.total);
    }
  },
  watch: {
    page(newVal) {
      this.localPage = newVal;
    },
    limit(newVal) {
      this.localLimit = newVal;
    }
  },
  methods: {
    onPageChange(page: number) {
      this.localPage = page;
      this.$emit("page-change", page);
    },
    onLimitChange(limit: number) {
      this.localLimit = limit;
      this.localPage = 1; // Reset to first page when changing limit
      this.$emit("limit-change", limit);
    }
  }
});
